module.exports = __webpack_public_path__ + "img/Loading_2.5fe4039b.gif";